<template>
  <div id="department" class="hw-wrap style3 ptb-100">
    <div class="container">
      <ul class="nav nav-tabs dp-tablist style2" role="tablist">
        <li class="nav-item">
          <button
            class="tab-link active"
            data-bs-toggle="tab"
            data-bs-target="#tab_1"
            type="button"
            role="tab"
          >
            <i class="flaticon-medicine"></i> Instant Medicine
          </button>
        </li>

        <li class="nav-item">
          <button
            class="tab-link"
            data-bs-toggle="tab"
            data-bs-target="#tab_2"
            type="button"
            role="tab"
          >
            <i class="flaticon-stethoscope"></i> Health Check
          </button>
        </li>

        <li class="nav-item">
          <button
            class="tab-link"
            data-bs-toggle="tab"
            data-bs-target="#tab_3"
            type="button"
            role="tab"
          >
            <i class="flaticon-kidney"></i> Kidney Solution
          </button>
        </li>

        <li class="nav-item">
          <button
            class="tab-link"
            data-bs-toggle="tab"
            data-bs-target="#tab_4"
            type="button"
            role="tab"
          >
            <i class="flaticon-blood"></i> Blood Test
          </button>
        </li>

        <li class="nav-item">
          <button
            class="tab-link"
            data-bs-toggle="tab"
            data-bs-target="#tab_5"
            type="button"
            role="tab"
          >
            <i class="flaticon-doctor-1"></i> Technicians
          </button>
        </li>

        <li class="nav-item">
          <button
            class="tab-link"
            data-bs-toggle="tab"
            data-bs-target="#tab_6"
            type="button"
            role="tab"
          >
            <i class="flaticon-dentistry"></i> Dentristy
          </button>
        </li>
      </ul>

      <div class="tab-content dp-tab-content">
        <div class="tab-pane fade show active" id="tab_1" role="tabpanel">
          <div class="row gx-5 align-items-center">
            <div class="col-lg-6 col-12 order-lg-1 order-2">
              <div class="hw-content">
                <div class="content-title style3 mb-30">
                  <span>Our Department</span>
                  <h2>
                    Take Care Of You &amp; <span> Family's Health</span> And
                    Well Being
                  </h2>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Distinctio laudantium eos minima sit harum eligendi nihil
                    illum rerum amet id.
                  </p>
                </div>

                <ul class="content-feature-list list-style mb-0">
                  <li>
                    <i class="ri-check-double-line"></i>Cardiovascular Services
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Orthopedic Surgery
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Top Qualified Doctors
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Cronic Disease Manage
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Advices &amp;
                    Care
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Research
                    Professional
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Trusted Medical
                    Treatment
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Emergency Support
                    Available
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-6 col-12 order-lg-2 order-1">
              <div class="hw-img">
                <img
                  src="../../assets/images/how-it-work/hw-img-4.jpg"
                  alt="Image"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="tab_2" role="tabpanel">
          <div class="row gx-5 align-items-center">
            <div class="col-lg-6 col-12 order-lg-1 order-2">
              <div class="hw-content">
                <div class="content-title style3 mb-30">
                  <span>Our Department</span>
                  <h2>
                    Take Care Of You &amp; <span> Family's Health</span> And
                    Well Being
                  </h2>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Distinctio laudantium eos minima sit harum eligendi nihil
                    illum rerum amet id.
                  </p>
                </div>

                <ul class="content-feature-list list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Cardiovascular Services
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Orthopedic Surgery
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Top Qualified Doctors
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Cronic Disease Manage
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Advices &amp;
                    Care
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Research
                    Professional
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Trusted Medical
                    Treatment
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Emergency Support
                    Available
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-6 col-12 order-lg-2 order-1">
              <div class="hw-img">
                <img
                  src="../../assets/images/how-it-work/hw-img-4.jpg"
                  alt="Image"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="tab_3" role="tabpanel">
          <div class="row gx-5 align-items-center">
            <div class="col-lg-6 col-12 order-lg-1 order-2">
              <div class="hw-content">
                <div class="content-title style3 mb-30">
                  <span>Our Department</span>
                  <h2>
                    Take Care Of You &amp; <span> Family's Health</span> And
                    Well Being
                  </h2>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Distinctio laudantium eos minima sit harum eligendi nihil
                    illum rerum amet id.
                  </p>
                </div>

                <ul class="content-feature-list list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Cardiovascular Services
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Orthopedic Surgery
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Top Qualified Doctors
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Cronic Disease Manage
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Advices &amp;
                    Care
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Research
                    Professional
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Trusted Medical
                    Treatment
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Emergency Support
                    Available
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-6 col-12 order-lg-2 order-1">
              <div class="hw-img">
                <img
                  src="../../assets/images/how-it-work/hw-img-4.jpg"
                  alt="Image"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="tab_4" role="tabpanel">
          <div class="row gx-5 align-items-center">
            <div class="col-lg-6 col-12 order-lg-1 order-2">
              <div class="hw-content">
                <div class="content-title style3 mb-30">
                  <span>Our Department</span>
                  <h2>
                    Take Care Of You &amp; <span> Family's Health</span> And
                    Well Being
                  </h2>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Distinctio laudantium eos minima sit harum eligendi nihil
                    illum rerum amet id.
                  </p>
                </div>

                <ul class="content-feature-list list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Cardiovascular Services
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Orthopedic Surgery
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Top Qualified Doctors
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Cronic Disease Manage
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Advices &amp;
                    Care
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Research
                    Professional
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Trusted Medical
                    Treatment
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Emergency Support
                    Available
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-6 col-12 order-lg-2 order-1">
              <div class="hw-img">
                <img
                  src="../../assets/images/how-it-work/hw-img-4.jpg"
                  alt="Image"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="tab_5" role="tabpanel">
          <div class="row gx-5 align-items-center">
            <div class="col-lg-6 col-12 order-lg-1 order-2">
              <div class="hw-content">
                <div class="content-title style3 mb-30">
                  <span>Our Department</span>
                  <h2>
                    Take Care Of You &amp; <span> Family's Health</span> And
                    Well Being
                  </h2>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Distinctio laudantium eos minima sit harum eligendi nihil
                    illum rerum amet id.
                  </p>
                </div>

                <ul class="content-feature-list list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Cardiovascular Services
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Orthopedic Surgery
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Top Qualified Doctors
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Cronic Disease Manage
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Advices &amp;
                    Care
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Research
                    Professional
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Trusted Medical
                    Treatment
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Emergency Support
                    Available
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-6 col-12 order-lg-2 order-1">
              <div class="hw-img">
                <img
                  src="../../assets/images/how-it-work/hw-img-4.jpg"
                  alt="Image"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="tab_6" role="tabpanel">
          <div class="row gx-5 align-items-center">
            <div class="col-lg-6 col-12 order-lg-1 order-2">
              <div class="hw-content">
                <div class="content-title style3 mb-30">
                  <span>Our Department</span>
                  <h2>
                    Take Care Of You &amp; <span> Family's Health</span> And
                    Well Being
                  </h2>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Distinctio laudantium eos minima sit harum eligendi nihil
                    illum rerum amet id.
                  </p>
                </div>

                <ul class="content-feature-list list-style">
                  <li>
                    <i class="ri-check-double-line"></i>Cardiovascular Services
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Orthopedic Surgery
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Top Qualified Doctors
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Cronic Disease Manage
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Advices &amp;
                    Care
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Medical Research
                    Professional
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Trusted Medical
                    Treatment
                  </li>
                  <li>
                    <i class="ri-check-double-line"></i>Emergency Support
                    Available
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-lg-6 col-12 order-lg-2 order-1">
              <div class="hw-img">
                <img
                  src="../../assets/images/how-it-work/hw-img-4.jpg"
                  alt="Image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurDepartment",
};
</script>